// extracted by mini-css-extract-plugin
export default {"checkbox":"NLw4Nq","checkboxError":"uRE6nl"};